import { executeWithRetry, StatusCodeRethrowFilter } from 'src/requests/fetchWrapper';
import loginServiceUrl from 'src/utils/authentication/loginServiceUrl';
import { ai } from '@sekoia/shared/utils/telemetryService';

interface DeviceLocation {
  locationId: string;
  primaryProfileId: string;
  allProfileIds: string[];
}

interface LocationRequest {
  url: string;
  method: string;
  body?: Record<string, unknown>;
}

export async function removeLocationAndPublicKeyForDevice(
  locationId: string | null,
  deviceId: string | null,
  customerId: string | undefined,
): Promise<void> {
  await removeDevicePublicKey(deviceId, customerId);

  const request: LocationRequest = {
    url: `/api/locations/${locationId}/device`,
    method: 'DELETE',
    body: {
      deviceId,
    },
  };

  await executeWithRetry(request);
}

export async function setLocationForDevice(
  locationId: string,
  deviceId: string | null,
  customerId: string,
  publicKey: string,
  administratorToken: string,
): Promise<void> {
  await setDevicePublicKey(deviceId, customerId, publicKey, administratorToken);

  const request: LocationRequest = {
    url: `/api/locations/${locationId}/device`,
    method: 'post',
    body: {
      deviceId,
      AdministratorToken: administratorToken,
    },
  };

  try {
    await executeWithRetry(request, new StatusCodeRethrowFilter(true));
  } catch (error) {
    ai.trackException(error, `Error removing public key`);
    try {
      removeDevicePublicKey(deviceId, customerId);
    } catch (removeError) {
      ai.trackException(removeError, `Error removing public key, after exception from add device`);
    }
    throw error;
  }
}

export async function updateLocationForDevice(locationId: string, deviceId: string | null): Promise<void> {
  const request: LocationRequest = {
    url: `/api/locations/${locationId}/device`,
    method: 'put',
    body: {
      deviceId,
    },
  };

  await executeWithRetry(request);
}

export async function getLocationForDevice(deviceId: string | null): Promise<DeviceLocation | undefined> {
  const request: LocationRequest = {
    url: `/api/locations/device/${deviceId}`,
    method: 'get',
  };
  return (await executeWithRetry(request, new StatusCodeRethrowFilter(false, [404, 403]))) as
    DeviceLocation | undefined;
}

async function removeDevicePublicKey(deviceId: string | null, customerId: string | undefined): Promise<void> {
  const request: LocationRequest = {
    url: `${loginServiceUrl()}/device/${deviceId}`,
    method: 'DELETE',
    body: {
      customerId,
    },
  };

  await executeWithRetry(request, new StatusCodeRethrowFilter(true));
}

async function setDevicePublicKey(
  deviceId: string | null,
  customerId: string,
  publicKey: string,
  administratorToken: string,
): Promise<void> {
  const request: LocationRequest = {
    url: `${loginServiceUrl()}/device/${deviceId}`,
    method: 'PUT',
    body: {
      publicKey,
      customerId,
      AdministratorToken: administratorToken,
    },
  };

  await executeWithRetry(request, new StatusCodeRethrowFilter(true));
}
